import { useContext } from 'react';
import { HostContext } from '../contexts';

export const useHost = () => {
  return useContext(HostContext);
};
